export default __webpack_public_path__ + "static/media/Priest's Bracers of the Nine Springs.6519abbf.jpg";